// extracted by mini-css-extract-plugin
export default {"filter":"filters_filter__kMtLb","filterLabel":"filters_filterLabel__Fvl9U"};